export default __webpack_public_path__ + "static/media/Group 5798.9e694ada.svg";